import { render, staticRenderFns } from "./ShopDeliveryPrice.vue?vue&type=template&id=523ec2d6&scoped=true&"
import script from "./ShopDeliveryPrice.vue?vue&type=script&lang=js&"
export * from "./ShopDeliveryPrice.vue?vue&type=script&lang=js&"
import style0 from "./ShopDeliveryPrice.vue?vue&type=style&index=0&id=523ec2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ec2d6",
  null
  
)

export default component.exports